import { Component, OnInit, Input } from '@angular/core';
import { favoriteStops } from '@app/constants';
import { Task } from '@app/shared/models/time.model';

@Component({
  selector: 'ty-save-favorites',
  templateUrl: './save-favorites.component.html',
  styleUrls: ['./save-favorites.component.scss'],
})
export class SaveFavoritesComponent implements OnInit {
  @Input() busId!: number;
  @Input() busname!: string;
  @Input() busCode!: string;
  @Input() stop!: number;
  @Input() stopName!: string;
  @Input() direction!: number;
  @Input() routes?: Task[] = [];
  @Input() disabled = false;
  isActive = false;

  constructor() {}

  ngOnInit(): void {
    this.enableActive();
  }

  enableActive(): void {
    const data = JSON.parse(localStorage.getItem(favoriteStops) || '{}');

    if (data[this.stop]) {
      this.isActive = true;
    }
  }

  /**
   *
   * @param stop
   */
  saveFavorites(): void {
    const data = JSON.parse(localStorage.getItem(favoriteStops) || '{}');

    this.isActive = !this.isActive;

    const storedRoute = data[this.stop];

    if (storedRoute) {
      delete data[this.stop];
    } else {
      data[this.stop] = {
        url: window.location.href,
        busId: this.busId,
        busname: this.busname,
        busCode: this.busCode,
        stop: this.stop,
        stopName: this.stopName,
        direction: this.direction,
        routes: this.routes,
      };
    }

    localStorage.setItem(favoriteStops, JSON.stringify(data));
  }
}
